export const SEO_PAGE_MIN_RESULTS = 4;
